module.exports = __webpack_public_path__ + "static/media/defaultAvatar4.d4c2aa00.svg";